export const DEFAULT_TIME_ZONE = "Asia/Kathmandu";

export const TEXTUAL_DATE_FORMAT = "MMMM DD, YYYY";

export const STANDARD_DATE_FORMAT = "YYYY-MM-DD";
